import { TAppState } from '../../types/appState';

export const selectContentFullscreenSelectedImageUid = (state: TAppState) => state.contentFullscreen.selectedImageUid;
